/* eslint-disable indent */
import { useEffect, useState } from 'react';
import ImageLink from '../../js/utils/ImageLink';

import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';

export default function MaximizingLeadership({ data }) {
  const [isMobile, setIsMobile] = useState(false);
  const [isArabic, setIsArabic] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [isMobile]);

  useEffect(() => {
    if (document.dir === 'rtl') {
      setIsArabic(true);
    } else {
      setIsArabic(false);
    }
  }, [isArabic]);

  return (
    <div className="maximizing-leadership-wrapper">
        <div className="leadership-section__header container">
          <MainTitle type="dark" className="text--2xl">
            <span>{data?.title1}</span>
            <span
              className={`${
                !isMobile ? 'decorated-line decorated-line--dark decorated-line--left' : ''
              } `}>
              {data?.title2 + ' ' + data?.title3}
            </span>
          </MainTitle>
        </div>
      <section className="leadership-section container">
        <div className="leadership-section__content">
          <p>{data?.text1}</p>
          <p>{data?.text2}</p>
        </div>

        <Icon name="spiral-arrow-down" className="spiral-arrow-icon" />

        <div className="leadership-section__media">
          <img src={ImageLink(data?.image?.url)} alt="child-making-robot" />
          <Icon name="leader" className="leader-icon" />
          {/* <Icon name="light-bulb" className="light-bulb-icon" /> */}
        </div>
      </section>
    </div>
  );
}
